/* =========================================================
   Affiche MUSCULATION « La Séance » — le board d'entraînement.
   API : SNMuscuSeance.render(data, opts) -> string SVG
     data : { date, title, place, prLift, prLoad, footer,
              e1..e6 (exercice), s1..s6 (séries × reps), c1..c6 (charge),
              pr1..pr6 ('1' = record du jour → badge PR + charge en accent) }
     opts : { palette }
   Auto-suffisant (aucune carte) → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 66;

  const PALETTES = {
    nuit:  { label: 'Nuit',  bg: '#0B2D5B', ink: '#F7F4ED', muted: '#93A1B8', accent: '#FF6B2C', line: '#1E4272', boxInk: '#0B2D5B' },
    craie: { label: 'Craie', bg: '#F7F4ED', ink: '#0B2D5B', muted: '#8B94A3', accent: '#FF6B2C', line: '#E3DDD0', boxInk: '#F7F4ED' },
    fonte: { label: 'Fonte', bg: '#15191F', ink: '#F5F2EA', muted: '#8A93A0', accent: '#FF6B2C', line: '#272D36', boxInk: '#15191F' },
    acier: { label: 'Acier', bg: '#E7E9EC', ink: '#14243B', muted: '#77808F', accent: '#FF6B2C', line: '#D3D7DD', boxInk: '#F7F4ED' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const fitSize = (text, maxW, maxSize, cwf, ls, minSize) => {
    const n = String(text).length || 1; minSize = minSize || 12;
    for (let s = maxSize; s > minSize; s -= 1) if (n * (cwf * s + ls) <= maxW) return s;
    return minSize;
  };

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.nuit;
    const cx = PW / 2;

    /* --- lignes d'exercices --- */
    const rows = [];
    for (let i = 1; i <= 6; i++) {
      const name = up(data['e' + i]).trim();
      if (!name) continue;
      rows.push({ name, sets: String(data['s' + i] || '').trim(), load: up(data['c' + i]).trim(), pr: String(data['pr' + i] || '') === '1' });
    }
    if (!rows.length) {
      ['SQUAT', 'DÉVELOPPÉ COUCHÉ', 'SOULEVÉ DE TERRE', 'TRACTIONS'].forEach(n => rows.push({ name: n, sets: '', load: '', pr: false }));
    }

    const title = up(data.title) || 'LA SÉANCE';
    // max 80 + baseline 202 : la boîte d'ascente Oswald (≈1,2× la taille) reste
    // à ≥20 px sous le sur-titre (baseline 78) — accents É compris.
    const titleSize = fitSize(title, 700, 80, 0.54, 4, 40);
    const sub = up(data.place).trim();

    const Y0 = 300, Y1 = 838;
    const step = (Y1 - Y0) / rows.length;
    let body = '';
    rows.forEach((r, i) => {
      const y = Y0 + step * i + step / 2;              // ligne centrée dans sa bande
      const nameSize = r.name.length > 22 ? 18 : r.name.length > 17 ? 21 : 24;
      body += `<text x="${MX}" y="${y + 8}" font-size="${nameSize}" font-weight="700" fill="${p.ink}" letter-spacing="1.5">${esc(r.name)}</text>`;
      if (r.pr) {
        const bx = MX + r.name.length * nameSize * 0.66 + 16;
        body += `<rect x="${bx}" y="${y - 15}" width="46" height="29" rx="7" fill="${p.accent}"/>`
          + `<text x="${bx + 23}" y="${y + 6}" font-size="17" font-weight="800" fill="${p.boxInk}" text-anchor="middle" letter-spacing="1">PR</text>`;
      }
      // charge : police adaptative (les charges texte comme « poids du corps » rétrécissent)
      const load = r.load || '—';
      const loadSize = load.length > 13 ? 26 : load.length > 9 ? 32 : 42;
      const loadW = load.length * loadSize * 0.54;             // avance Oswald
      body += `<text x="${PW - MX}" y="${y + 12}" text-anchor="end" font-family="Oswald" font-size="${loadSize}" font-weight="700" fill="${r.pr ? p.accent : p.ink}">${esc(load)}</text>`;
      // séries : ancrées juste à gauche de la charge (jamais de chevauchement)
      if (r.sets) body += `<text x="${(PW - MX - loadW - 24).toFixed(0)}" y="${y + 7}" text-anchor="end" font-size="18" font-weight="600" fill="${p.muted}" letter-spacing="1">${esc(r.sets)}</text>`;
      if (i < rows.length - 1) body += `<line x1="${MX}" y1="${(y + step / 2).toFixed(1)}" x2="${PW - MX}" y2="${(y + step / 2).toFixed(1)}" stroke="${p.line}" stroke-width="1.5"/>`;
    });

    /* --- bandeau PR du jour (auto depuis les lignes si non renseigné) --- */
    const auto = rows.find(r => r.pr);
    const prLift = up(data.prLift).trim() || (auto ? auto.name : '');
    const prLoad = up(data.prLoad).trim() || (auto ? auto.load : '');
    const prTxt = [prLift, prLoad].filter(Boolean).join(' · ');
    const prSize = prTxt.length > 30 ? 30 : prTxt.length > 24 ? 36 : 44;

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<text x="${cx}" y="78" font-size="19" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="5">${esc(up(data.date) || 'VOTRE SÉANCE')}</text>
<text x="${cx}" y="202" font-family="Oswald" font-size="${titleSize}" font-weight="700" fill="${p.ink}" text-anchor="middle" letter-spacing="4">${esc(title)}</text>
${sub ? `<text x="${cx}" y="236" font-size="17" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="3.5">${esc(sub)}</text>` : ''}
${body}
${prTxt ? `<rect x="54" y="872" width="${PW - 108}" height="118" rx="16" fill="${p.accent}"/>
<text x="${cx}" y="916" font-size="17" font-weight="700" fill="${p.boxInk}" text-anchor="middle" letter-spacing="6">RECORD DU JOUR</text>
<text x="${cx}" y="966" font-family="Oswald" font-size="${prSize}" font-weight="700" fill="${p.boxInk}" text-anchor="middle" letter-spacing="1">${esc(prTxt)}</text>` : ''}
<text x="${cx}" y="1038" font-size="15" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="4.5">${esc(up(data.footer) || "CARNET D'ENTRAÎNEMENT")}</text>
</svg>`;
  }

  window.SNMuscuSeance = { render, PALETTES };
})();
